export const galleryHeaderId = 'gallery-header-id'
